import React, { memo } from 'react';
import '../styles/components/ProductSearchForm.scss';

/**
 * ProductSearchForm component for filtering products in admin panel
 * Provides search input and filter dropdowns for warehouses and categories
 * @param {Object} props - Component props
 * @param {Function} props.onSearch - Callback function when search parameters change
 * @param {Object} props.filters - Current filter values
 * @param {Array} props.warehouses - Available warehouses for filtering
 * @param {Array} props.categories - Available categories for filtering
 * @author msoler18
 */
const ProductSearchForm = ({ onSearch, filters, warehouses = [], categories = [] }) => {
  /**
   * Handle input changes and propagate to parent component
   * @param {string} field - Field name to update
   * @param {string} value - New value for the field
   */
  const handleInputChange = (field, value) => {
    onSearch({
      ...filters,
      [field]: value
    });
  };

  /**
   * Clear all search filters and reset to default state
   */
  const handleClearFilters = () => {
    onSearch({
      search: '',
      warehouse: '',
      category: ''
    });
  };

  const hasActiveFilters = filters.search || filters.warehouse || filters.category;

  return (
    <div className="product-search-form">
      <div className="product-search-form__row">
        <div className="product-search-form__field">
          <label htmlFor="search-input">Buscar productos</label>
          <input
            id="search-input"
            type="text"
            placeholder="Título, referencia o descripción..."
            value={filters.search || ''}
            onChange={(e) => handleInputChange('search', e.target.value)}
            className="form-control"
          />
        </div>

        <div className="product-search-form__field">
          <label htmlFor="warehouse-select">Proveedor</label>
          <select
            id="warehouse-select"
            value={filters.warehouse || ''}
            onChange={(e) => handleInputChange('warehouse', e.target.value)}
            className="form-control"
          >
            <option value="">Todos los proveedores</option>
            {warehouses.map(warehouse => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>

        <div className="product-search-form__field">
          <label htmlFor="category-select">Categoría</label>
          <select
            id="category-select"
            value={filters.category || ''}
            onChange={(e) => handleInputChange('category', e.target.value)}
            className="form-control"
          >
            <option value="">Todas las categorías</option>
            {categories.map(category => (
              <option key={category.id} value={category.name}>
                {category.name}
              </option>
            ))}
          </select>
        </div>

        {hasActiveFilters && (
          <div className="product-search-form__actions">
            <button
              type="button"
              onClick={handleClearFilters}
              className="btn btn-outline-secondary"
            >
              Limpiar filtros
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(ProductSearchForm);